"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * ![blue 50](https://mui.com/static/colors-preview/blue-50-24x24.png) ![blue 100](https://mui.com/static/colors-preview/blue-100-24x24.png) ![blue 200](https://mui.com/static/colors-preview/blue-200-24x24.png) ![blue 300](https://mui.com/static/colors-preview/blue-300-24x24.png) ![blue 400](https://mui.com/static/colors-preview/blue-400-24x24.png) ![blue 500](https://mui.com/static/colors-preview/blue-500-24x24.png) ![blue 600](https://mui.com/static/colors-preview/blue-600-24x24.png) ![blue 700](https://mui.com/static/colors-preview/blue-700-24x24.png) ![blue 800](https://mui.com/static/colors-preview/blue-800-24x24.png) ![blue 900](https://mui.com/static/colors-preview/blue-900-24x24.png) ![blue A100](https://mui.com/static/colors-preview/blue-A100-24x24.png) ![blue A200](https://mui.com/static/colors-preview/blue-A200-24x24.png) ![blue A400](https://mui.com/static/colors-preview/blue-A400-24x24.png) ![blue A700](https://mui.com/static/colors-preview/blue-A700-24x24.png)
 */
exports.default = {
    /**
     * Preview: ![blue 50](https://mui.com/static/colors-preview/blue-50-24x24.png)
     */
    50: '#1A345B',
    /**
     * Preview: ![blue 100](https://mui.com/static/colors-preview/blue-100-24x24.png)
     */
    100: '#1A345B',
    /**
     * Preview: ![blue 200](https://mui.com/static/colors-preview/blue-200-24x24.png)
     */
    200: '#1A345B',
    /**
     * Preview: ![blue 300](https://mui.com/static/colors-preview/blue-300-24x24.png)
     */
    300: '#1A345B',
    /**
     * Preview: ![blue 400](https://mui.com/static/colors-preview/blue-400-24x24.png)
     */
    400: '#1A345B',
    /**
     * Preview: ![blue 500](https://mui.com/static/colors-preview/blue-500-24x24.png)
     */
    500: '#1A345B',
    /**
     * Preview: ![blue 600](https://mui.com/static/colors-preview/blue-600-24x24.png)
     */
    600: '#1A345B',
    /**
     * Preview: ![blue 700](https://mui.com/static/colors-preview/blue-700-24x24.png)
     */
    700: '#1A345B',
    /**
     * Preview: ![blue 800](https://mui.com/static/colors-preview/blue-800-24x24.png)
     */
    800: '#1A345B',
    /**
     * Preview: ![blue 900](https://mui.com/static/colors-preview/blue-900-24x24.png)
     */
    900: '#1A345B',
    /**
     * Preview: ![blue A100](https://mui.com/static/colors-preview/blue-A100-24x24.png)
     */
    A100: '#1A345B',
    /**
     * Preview: ![blue A200](https://mui.com/static/colors-preview/blue-A200-24x24.png)
     */
    A200: '#1A345B',
    /**
     * Preview: ![blue A400](https://mui.com/static/colors-preview/blue-A400-24x24.png)
     */
    A400: '#1A345B',
    /**
     * Preview: ![blue A700](https://mui.com/static/colors-preview/blue-A700-24x24.png)
     */
    A700: '#1A345B',
};
